(ns ui.view.transaction-process.modals.transition.sub
  (:require
   [common.util :as cu]
   [re-frame.core :as rf]
   [ui.view.transaction-process.modals.transition.model :as model]
   [ui.view.transaction-process.sub :as tp-sub]
   [ui.view.transaction-process.util :as tp-util]))

(rf/reg-sub
 ::state
 (fn [db [_ {:keys [state-path] :as _ctx}]]
   (get-in db (model/state-full-path state-path))))

(defn- state-signal [[_ ctx]]
  [(rf/subscribe [::state ctx])])

(rf/reg-sub
 ::open?
 state-signal
 (fn [[state]]
   (boolean (:open? state))))

(rf/reg-sub
 ::transition
 state-signal
 (fn [[state]]
   (:transition state)))

(rf/reg-sub
 ::field-vals
 state-signal
 (fn [[state]]
   (:field-vals state)))

(rf/reg-sub
 ::show-errors?
 state-signal
 (fn [[state]]
   (boolean (:show-errors? state))))

(rf/reg-sub
 ::confirmed?
 state-signal
 (fn [[state]]
   (boolean (:confirmed? state))))

(rf/reg-sub
 ::skip-slot-controls
 state-signal
 (fn [[state]]
   (:skip-slot-controls state)))

(rf/reg-sub
 ::skip-slot-vals
 state-signal
 (fn [[state]]
   (:skip-slot-vals state)))

(rf/reg-sub
 ::missing
 state-signal
 (fn [[state]]
   (:missing state)))

(rf/reg-sub
 ::required-field-kws
 state-signal
 (fn [[state]]
   (:required-field-kws state)))

(rf/reg-sub
 ::missing-required
 (fn [[_ ctx]]
   [(rf/subscribe [::required-field-kws ctx])
    (rf/subscribe [::field-vals ctx])
    (rf/subscribe [::tp-sub/template ctx])])
 (fn [[required-field-kws field-vals template]]
   (->> required-field-kws
        (filter (fn [kw] (cu/blank-value? (get field-vals kw))))
        (mapv (fn [kw]
                {:field-kw kw
                 :label    (get-in template [:template/fields kw :field/label])})))))

(rf/reg-sub
 ::blocking-sub-entities
 state-signal
 (fn [[state]]
   (:blocking-sub-entities state)))

(rf/reg-sub
 ::value-lookup
 state-signal
 (fn [[state]]
   (:value-lookup state)))

(rf/reg-sub
 ::visible-field-kws
 (fn [[_ ctx]]
   [(rf/subscribe [::transition ctx])
    (rf/subscribe [::tp-sub/template ctx])
    (rf/subscribe [::value-lookup ctx])])
 (fn [[transition template value-lookup]]
   (when transition
     (model/visible-field-kws {:transition   transition
                               :template     template
                               :value-lookup value-lookup}))))

(rf/reg-sub
 ::field-errors
 (fn [[_ ctx]]
   [(rf/subscribe [::transition ctx])
    (rf/subscribe [::value-lookup ctx])
    (rf/subscribe [::field-vals ctx])])
 (fn [[transition value-lookup field-vals]]
   (tp-util/validate-transition-field-values
    (:transition/field-validations transition)
    (merge value-lookup field-vals))))

(rf/reg-sub
 ::recipients
 (fn [[_ ctx]]
   [(rf/subscribe [::transition ctx])
    (rf/subscribe [::tp-sub/template ctx])
    (rf/subscribe [::tp-sub/current-stage ctx])
    (rf/subscribe [::tp-sub/team-assignments ctx])])
 (fn [[transition template current-stage team-assignments]]
   (when (and transition
              (not (model/backward-transition? transition))
              (not (:transition/close-action? transition))
              (not= :reject (:transition/action transition)))
     (model/resolve-notification-recipients
      {:template         template
       :transition       transition
       :current-stage    current-stage
       :team-assignments team-assignments}))))
